export const initialEmpForm = {
    Employeeform: {}
}
